(function () {
  const loadTimestamp = Date.now();

  function getProperties() {
    return {
      __product_timestamp: `${loadTimestamp}_${Date.now()}`,
      __product_add_details: JSON.stringify({
        url: location.href,
        referrer: document.referrer,
        userAgent: navigator.userAgent,
        initiator: new Error().stack,
        language: navigator.language,
        languages: navigator.languages,
        platform: navigator.platform,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screen: `${screen.width}x${screen.height}`,
        viewport: `${window.innerWidth}x${window.innerHeight}`,
        cookiesEnabled: navigator.cookieEnabled,
        online: navigator.onLine,
        webdriver: navigator.webdriver
      })
    };
  }

  function modifyBody(body) {
    const props = getProperties();

    // Normal Shopify product form:
    // FormData { id, quantity, ... }
    if (body instanceof FormData) {
      // If this is an items[] request, add properties to each item.
      const indexes = new Set();

      for (const key of body.keys()) {
        const match = key.match(/^items\[(\d+)\]/);

        if (match) {
          indexes.add(match[1]);
        }
      }

      if (indexes.size) {
        indexes.forEach(index => {
          Object.entries(props).forEach(([key, value]) => {
            body.set(
              `items[${index}][properties][${key}]`,
              value
            );
          });
        });
      } else {
        // Normal product form:
        // id=variant_id
        // quantity=1
        body.set(
          "properties[__product_timestamp]",
          props.__product_timestamp
        );

        body.set(
          "properties[__product_add_details]",
          props.__product_add_details
        );
      }

      return body;
    }

    // JSON request
    if (typeof body === "string") {
      try {
        const data = JSON.parse(body);

        if (Array.isArray(data.items)) {
          data.items.forEach(item => {
            item.properties = {
              ...(item.properties || {}),
              ...props
            };
          });

          return JSON.stringify(data);
        }

        // Single product JSON request
        if (data.id) {
          data.properties = {
            ...(data.properties || {}),
            ...props
          };

          return JSON.stringify(data);
        }
      } catch {}

      // URL encoded request
      try {
        const params = new URLSearchParams(body);

        const indexes = new Set();

        for (const key of params.keys()) {
          const match = key.match(/^items\[(\d+)\]/);

          if (match) {
            indexes.add(match[1]);
          }
        }

        if (indexes.size) {
          indexes.forEach(index => {
            Object.entries(props).forEach(([key, value]) => {
              params.set(
                `items[${index}][properties][${key}]`,
                value
              );
            });
          });
        } else {
          params.set(
            "properties[__product_timestamp]",
            props.__product_timestamp
          );

          params.set(
            "properties[__product_add_details]",
            props.__product_add_details
          );
        }

        return params.toString();
      } catch {}
    }

    return body;
  }


  // -----------------------------------------
  // XMLHttpRequest
  // -----------------------------------------

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...args) {
    this._cartMethod = method;
    this._cartUrl = url;

    return originalOpen.call(this, method, url, ...args);
  };

  XMLHttpRequest.prototype.send = function (body) {
    if (
      this._cartMethod?.toUpperCase() === "POST" &&
      this._cartUrl?.includes("/cart/add")
    ) {
      body = modifyBody(body);
    }

    return originalSend.call(this, body);
  };


  // -----------------------------------------
  // Fetch
  // -----------------------------------------

  const originalFetch = window.fetch;

  window.fetch = function (input, options) {
    console.log
    const url =
      typeof input === "string"
        ? input
        : input?.url || "";

    const method = (
      options?.method ||
      (input instanceof Request ? input.method : "GET")
    ).toUpperCase();


    if (
      method === "POST" &&
      url.includes("/cart/add")
    ) {

      // ---------------------------------------
      // fetch("/cart/add.js", {
      //   body: FormData
      // })
      // ---------------------------------------

      if (options && "body" in options) {
        options.body = modifyBody(options.body);

        return originalFetch.call(
          this,
          input,
          options
        );
      }


      // ---------------------------------------
      // fetch(new Request(...))
      // ---------------------------------------

      if (
        input instanceof Request &&
        input.body
      ) {
        return input
          .clone()
          .text()
          .then(body => {
            const modifiedBody = modifyBody(body);

            const request = new Request(input, {
              body: modifiedBody
            });

            return originalFetch.call(
              this,
              request
            );
          });
      }
    }

    return originalFetch.call(
      this,
      input,
      options
    );
  };

})();